import React from 'react';
import { Box } from '@mui/material';
import { FaWheelchair } from 'react-icons/fa';
import {
    Navigate,
    Route,
    Routes,
    useLocation,
    useNavigate
} from 'react-router-dom';
import Header from '../../Common/Header/Header';
import ChartsContainer from '../Common/ChartsContainer';
import PeopleWithDisabilitiesWrapper from './PeopleWithDisabilities';

const menus = [
    {
        title: 'Pessoas com Deficiência',
        path: '/governanceroom/dashboardunifiedregistry/disability/people-with-disabilities',
        icon: <FaWheelchair style={{ marginRight: '5px' }} />
    }
];

const titleMap = {
    '/governanceroom/dashboardunifiedregistry/disability/people-with-disabilities':
        'Perfil das Pessoas com Deficiência'
};

const Disability = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleHomeClick = () => {
        navigate('/governanceroom/dashboardunifiedregistry');
    };

    return (
        <Box>
            <Header menus={menus} onHomeClick={handleHomeClick} />
            <Box className="content">
                <ChartsContainer
                    title={titleMap[location.pathname]}
                    className="services-container-dashboards"
                >
                    <Routes>
                        <Route
                            path="/"
                            element={<Navigate to="people-with-disabilities" />}
                        />

                        <Route
                            path="people-with-disabilities"
                            element={<PeopleWithDisabilitiesWrapper />}
                        />
                    </Routes>
                </ChartsContainer>
            </Box>
        </Box>
    );
};

export default Disability;
